import { UserModel } from "@/components/task-forms/models";
import { ProjectModel } from "@/models";

/**Модель сотрудника команды */
export class TeammateModel extends UserModel {
  /**Проекты сотрудника */
  Projects: ProjectModel[] = [];

  constructor(obj?: Partial<TeammateModel>) {
    super();
    if (obj) Object.assign(this, obj);
  }
}
